import * as React from "react";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Typography from "@mui/material/Typography";
import { Divider } from "@mui/material";
import TextWithReadMore from "./TextWithReadMore";
import Modal from "@mui/material/Modal";
import ToolTip from "./ToolTip";
import SocialHandles from "./SocialHandles";
import { Icon } from "./Icon";
import { sentimentRating } from "../utils/sentimentRating";
import "./card.css";
import { LabelImportant } from "@mui/icons-material";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  width: "40%",
  padding: "10px 20px 0px 20px",
  border: "none",
};
export default function StoryVelocityCard({open,handleClose, positive = true, 
  title, text, category, channel, coins, curated, handle,
   score, source, icons, datetime, onReadMore }) {

  const positiveURL = "./assets/positiveReviews.png";
  const negativeURL = "./assets/negativeReviews.png";
  const cardRef = React.useRef();

  function isMobile() {
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const minSize = 450;
    return screenWidth <= minSize;
  }
  const openModal = () => {
    let cardDetails = {
      positive: positive,
      title: title,
      text: text,
      category: category,
      channel: channel,
      coins: coins,
      curated: curated,
      score: score,
      handle: handle,
      icons: icons,
      datetime: datetime,
    };
    onReadMore(cardDetails);
  };
  function headingText() {
    if (title == "" && isMobile()) { return text?.slice(0, 15) + ".." }
    else if (title == "" && !isMobile()) { return text?.slice(0, 52) + ".." }
    else if (isMobile()) { return title?.slice(0, 15) + ".." }
    else { return title?.slice(0, 52) + ".." }
  }
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{     
 
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <Card
        sx={{
          borderRadius: "10px",
          backgroundImage: `url(${positive ? positiveURL : negativeURL})`,
          backgroundOrigin: "center",
          backgroundSize: "cover",
          manHeight: "100px",
          height: isMobile() ? "170px" : "260px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          paddingTop: "5px",
          "@media (min-width: 768px)": {
            width: "500px",
          },

          ...style,
          "@media (max-width: 768px)": {
            width: "80%",
          },
        }}
        elevation={5}
      >
        <CardHeader
          sx={{
            // Card Header
            // textAlign: "-webkit-center",
            padding: isMobile() ? " 0px 30px" : "5px 16px",
            minHeight: "15px",
            maxHeight: "105px",
            overflow: "hidden",
            // backgroundColor:"yellowgreen",
            // lineClamp: "2",
            // WebkitLineClamp: "2",
          }}
          action={isMobile() ? (
            <Typography sx={{ color: positive ? "#4F9F65" : "#E56262", fontWeight: "small", fontSize: "12px" }}>
              {(score * 100).toFixed(0)}{"%"}

            </Typography>
          ) : (
            <ToolTip placement="top" arrow title={`${curated ? "curated" : "AI"}`}>
              <b style={{ color: "white", fontSize: "18px", }}>{curated ? "C" : "AI"}</b>
            </ToolTip>
          )}

          // action={
          //   <ToolTip placement="top" arrow title={`${curated ? "curated" : "AI"}`}>
          //     <b style={{color: "white", fontSize: "18px",}}>{curated ? "C" : "AI"}</b>
          //   </ToolTip>
          // }
          title={
            <Typography className="card-title" noWrap sx={{ display: "grid", whiteSpace: "break-spaces", fontSize: isMobile() ? "10px" : "15px", fontFamily: "Inter", fontWeight: "600", textAlign: "center", lineHeight: "1.4", lineClamp: 2, whiteSpace: title === "" ? "nowrap" : "normal" }}>
              {headingText()}
            </Typography>
          }
        />

        <CardContent className="card-content" ref={cardRef} sx={{ height: isMobile() ? "80px" : "160px" }}>
          <TextWithReadMore text={text} maxCharCount={isMobile() ? 150 : 190} onReadMore={openModal} />
        </CardContent>
        <CardActions
          sx={{
            display: "flex",
            paddingRight: "20px",
            justifyContent: "space-between",
            paddingLeft: "20px",
            gap: "10px",
            flexDirection: "column",
            alignItems: "center",
            // maxheight: "20px",
            height: isMobile() ? "15px" : "auto",
            flexDirection: "row",
            "@media (min-width: 768px)": {
              // backgroundColor:"red",
              alignItems: "flex-start",
            },
          }}
        >
          <Box className="icon-wrapper" sx={{ display: "flex", gap: isMobile() ? "3px" : "5px", width: "max-content", overflow: "scroll", marginLeft: isMobile() ? "-5px" : "0px" }}>
            {coins?.map?.((coin) => (
              <ToolTip placement="top" arrow title={coin}>
                <Box sx={{ display: "flex", alignItems: "center", gap: isMobile() ? "3px" : "5px" }}>
                  <Icon name={coin.toLowerCase()} url={icons?.[coin.toUpperCase()]} />
                  <Typography sx={{ fontSize: isMobile() ? "8px" : "10px" }}>{coin}</Typography>
                </Box>
              </ToolTip>
            ))}
          </Box>
          {isMobile() &&
            <Typography noWrap sx={{ color: "#474747", fontWeight: "bold", fontSize: "10px" }}>
              {datetime ? new Date(datetime).toLocaleDateString() : new Date().toLocaleDateString()}
            </Typography>
          }
          {!isMobile() &&
            <Typography sx={{ color: "black", fontWeight: "bold" }}>{category}</Typography>
          }
        </CardActions>
        <Divider />

        <CardActions
          sx={{
            // Footer of cards
            display: "flex",
            justifyContent: "space-between",
            paddingRight: "20px",
            paddingLeft: "20px",
            alignItems: "center",
            // paddingBottom:"12px",
            // backgroundColor:"blue",
            gap: "10px",
            "@media (min-width: 768px)": {
              flexDirection: "row",
            },
            height: isMobile() ? "30px" : "55px",
          }}
        >
          {curated && <Typography>{source} </Typography>}
          <SocialHandles icon={channel} handle={handle} sx={{ display: isMobile() ? "grid" : "flex" }} />
          {isMobile() &&
            <Typography sx={{ color: "black", fontWeight: "small", fontSize: "12px" }}>{category}</Typography>
          }
          {!isMobile() &&
            <Typography sx={{ color: positive ? "#4F9F65" : "#E56262", fontWeight: "bold" }}>
              Score : {(score * 100).toFixed(0)}{"%"}
            </Typography>
          }
          {!isMobile() &&
            <Typography noWrap sx={{ color: "#474747", fontWeight: "bold", fontSize: "14px" }}>
              {datetime ? new Date(datetime).toLocaleDateString() : new Date().toLocaleDateString()}
            </Typography>
          }
          {/* <Typography sx={{color: positive ? "#4F9F65" : "#E56262", fontWeight: "bold"}}>
          {positive && "+"}
          {score?.toFixed(2)*100}{"%"}{`(` + sentimentRating(score?.toFixed(2)) + `)`}
        </Typography>
        <Typography noWrap sx={{color: "#474747", fontWeight: "bold", fontSize: "14px"}}>
          {datetime ? new Date(datetime).toLocaleDateString() : new Date().toLocaleDateString()}
        </Typography> */}
        </CardActions>
      </Card>
    </Modal>
  );
}
